import { ElementType } from 'react';
import { CategoryCardFragment } from '../../queries/getCategorySetPageAtBuildTime';
import { ModuleCategoryCard } from './types';

// Formats graphql ShopCategoryCard Fragment to CategoryCardProps
export const formatCategoryCards = ({
  cta,
  title,
  image,
  description,
  href,
  category: { id },
  linkAs,
}: CategoryCardFragment & {
  href: string;
  linkAs?: ElementType;
}): ModuleCategoryCard => ({
  categoryId: id,
  href,
  image: image || undefined,
  title: title || undefined,
  description: description || undefined,
  cta: cta ? { href, text: cta.text } : undefined,
  linkAs,
});
